/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppVersionOnAzure
 */
export interface AppVersionOnAzure {
    /**
     * 
     * @type {Array<number>}
     * @memberof AppVersionOnAzure
     */
    notification_days?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionOnAzure
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof AppVersionOnAzure
     */
    rollout_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AppVersionOnAzure
     */
    version: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionOnAzure
     */
    go_live: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionOnAzure
     */
    update_complete: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppVersionOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof AppVersionOnAzure
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AppVersionOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof AppVersionOnAzure
     */
    _ts: number;
}

/**
 * Check if a given object implements the AppVersionOnAzure interface.
 */
export function instanceOfAppVersionOnAzure(value: object): value is AppVersionOnAzure {
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('go_live' in value) || value['go_live'] === undefined) return false;
    if (!('update_complete' in value) || value['update_complete'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    return true;
}

export function AppVersionOnAzureFromJSON(json: any): AppVersionOnAzure {
    return AppVersionOnAzureFromJSONTyped(json, false);
}

export function AppVersionOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'notification_days': json['notification_days'] == null ? undefined : json['notification_days'],
        'required': json['required'],
        'rollout_timestamp': json['rollout_timestamp'] == null ? undefined : json['rollout_timestamp'],
        'version': json['version'],
        'go_live': json['go_live'],
        'update_complete': json['update_complete'],
        'object_type': json['object_type'],
        'id': json['id'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
    };
}

export function AppVersionOnAzureToJSON(json: any): AppVersionOnAzure {
    return AppVersionOnAzureToJSONTyped(json, false);
}

export function AppVersionOnAzureToJSONTyped(value?: AppVersionOnAzure | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification_days': value['notification_days'],
        'required': value['required'],
        'rollout_timestamp': value['rollout_timestamp'],
        'version': value['version'],
        'go_live': value['go_live'],
        'update_complete': value['update_complete'],
        'object_type': value['object_type'],
        'id': value['id'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

